import React from "react"
import './homepage.css'
import News from './News'

export default function HomePage({ }) {
    return (<React.Fragment>
        <p>For thousands of years our people have occupied a vast area, stretching far across a great
            territory known as the Great Basin, there was no division and people were free to travel from
            village to village trading with each other and sharing what they had. Each village or family
            clan had their own headman, spiritual leader, and warriors. Several clans or family groups
            would band together for hunting or exploring as they chose and all were content with this
            way of life.</p>
        <p>Historically we Timpanogos Indians were what is known as hunter gatherers. The men spent
            their time hunting meat and insuring the safety of the people. The woman and children
            gathered nuts seeds and roots and made clothing out of hides, furs, and the soft lining of the
            sage brush. Our people are written by some as "sun worshippers" as we gathered early and
            rejoiced with song as the first morning light appeared. This was not a worship of the sun but
            a reverence of the new day giving thanks to the Creator above for he had blessed us once
            again with the morning light.</p>
        <br />
        <iframe width="560" height="315" src="https://www.youtube.com/embed/yeRdtUGsZaQ?si=QZ2gFX4McbvAsNBq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
        <p className="stay-connected" >STAY CONNECTED</p>
        <p className="stay-connected" >@TimpanogosTribalNation</p>
        <News />
    </React.Fragment>)
}